import { useCallback } from 'react';
import { useGetStreamData } from '../useGetStreamData';

export const useAutonomousKartInfo = () => {
	const { getStreamData } = useGetStreamData();

	const updateAutonomousKartInfo = useCallback(
		(prevState, stream) => {
			const autonomousKart = { ...prevState.autonomousKart };

			if (stream['/parking_available']) {
				autonomousKart.parkingAvailable = getStreamData(
					stream,
					'/parking_available',
				);
			}

			if (stream['/get_target_speed']) {
				autonomousKart.cruiseTargetSpeed = getStreamData(
					stream,
					'/get_target_speed',
				);
			}

			return autonomousKart;
		},
		[getStreamData],
	);

	return { updateAutonomousKartInfo };
};
